import { BehaviorSubject, Subject } from "rxjs";

class DeviceService {
    private static MOBILE_DEVICE_WIDTH: number = 991.98;

    private _window: JQuery<Window> = null!;

    private _isMobile: BehaviorSubject<boolean> = null!;

    public get isMobile(): Subject<boolean> {
        return this._isMobile;
    }

    public checkIsMobile(): boolean {
        return this._window.get(0)!.matchMedia(`(max-width: ${DeviceService.MOBILE_DEVICE_WIDTH}px)`).matches;
    }

    private handleResize(): void {
        this._isMobile.next(this.checkIsMobile());
    }

    private bindEvents(): void {
        this._window.on("orientationchange resize", () => this.handleResize());
    }

    private initContext(): void {
        this._window = $(window);
        this._isMobile = new BehaviorSubject(this.checkIsMobile());
    }

    public init(): void {
        this.initContext();
        this.bindEvents();
    }
}

export const deviceService = new DeviceService();
